"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _gridView = require("../components/gridView");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ActiveSpeakerView = function ActiveSpeakerView() {
  var dominantSpeaker = (0, _reactSdk.useHMSStore)(_reactSdk.selectDominantSpeaker);
  var latestDominantSpeakerRef = (0, _react.useRef)(dominantSpeaker);
  var peers = ((0, _reactSdk.useHMSStore)(_reactSdk.selectPeers) || []).filter(function (peer) {
    return peer.videoTrack || peer.audioTrack || peer.auxiliaryTracks.length > 0;
  });
  // if there is no current dominant speaker latest keeps pointing to last
  if (dominantSpeaker) {
    latestDominantSpeakerRef.current = dominantSpeaker;
  }
  if (peers.length === 0) {
    return null;
  }
  // show local peer if there hasn't been any dominant speaker
  var activeSpeaker = latestDominantSpeakerRef.current || peers[0];
  var showSidePane = activeSpeaker && peers.length > 1;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      size: "100%",
      "@lg": {
        flexDirection: "column"
      }
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_gridView.GridCenterView, {
      peers: [activeSpeaker],
      maxTileCount: 1,
      hideSidePane: !showSidePane
    }), showSidePane && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gridView.GridSidePaneView, {
      peers: peers.filter(function (peer) {
        return peer.id !== activeSpeaker.id;
      })
    })]
  });
};
var _default = ActiveSpeakerView;
exports["default"] = _default;